class InstalatorConfirmedUsersController {
    static controller($scope) {
        'ngInject';
    };
}

export default InstalatorConfirmedUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/instalator/instalator-confirmed.users.controller.js